module.exports = "/images/collect-customer-information.svg?9eaa8ec65fcb255eefd4b79a40c2fbee";